import React, {useContext, useMemo} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {useRouter} from '../../hooks/useRouter';
import {ROUTES} from '../../configs/routes';
import {LanguageContext} from '../../context/LanguageContext';

import './BreadCrumbs.less';

function BreadCrumbs({data}) {
  const language = useContext(LanguageContext);

  const {match} = useRouter();

  const breadCrumbsData = useMemo(() => {
    const rData = [{route: '/', description: {ru: 'Главная', en: 'Main'}}];

    const currentRoute = _.find(ROUTES, {route: match.path});

    if (currentRoute) {
      const routeBreadcrumbs = currentRoute.breadcrumbs || [];

      if (!routeBreadcrumbs.length) {
        return [];
      }

      const routesArray = [];

      routeBreadcrumbs.forEach((b) => {
        const getBData = () => {
          if (_.isFunction(b.description)) {
            const routeParam = match.params[b.param];
            if (Array.isArray(data)) {
              const breadCrumbParam = data.find((_data) => _data.param === b.param);
              if (routeParam) {
                return {
                  description: breadCrumbParam ? b.description(breadCrumbParam.data) : {},
                  route: `${routeParam}`,
                };
              }
            } else if (_.isObject(data)) {
              if (routeParam) {
                return {
                  description: b.description(data.data),
                  route: `${routeParam}`,
                };
              }
            }
            return {};
          }
          return b;
        };

        const bData = getBData();

        if (_.isObject(bData) && !Array.isArray(bData)) {
          if (!_.isEmpty(bData.description)) {
            rData.push({
              route: routesArray.length ? `/${routesArray.join('/')}/${bData.route}` : `/${bData.route}`,
              description: bData.description,
            });
            routesArray.push(bData.route);
          }
        }
      });
    }

    return rData;
  }, [match, data, language]);

  if (!breadCrumbsData.length) {
    return null;
  }

  return (
    <div className="breadcrumbs">
      <ul className="breadcrumbs_list">
        {breadCrumbsData.map((breadCrumb, index) => (
          <li className="breadcrumbs_item" key={breadCrumb.description[language]}>
            {index === breadCrumbsData.length - 1 ? (
              <span className="breadcrumbs_page-name">{breadCrumb.description[language]}</span>
            ) : (
              <Link to={breadCrumb.route} className="breadcrumbs_link">{breadCrumb.description[language]}</Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

BreadCrumbs.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
};


export default BreadCrumbs;
